module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', [_c('v-tabs', {
    attrs: {
      "grow": _vm.$vuetify.breakpoint.smAndDown,
      "slider-color": "primary",
      "color": "transparent"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('v-tab', {
      key: tab.id,
      attrs: {
        "to": tab.id
      }
    }, [_vm._v("\n                " + _vm._s(tab.text) + "\n            ")])
  })), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-layout', [_c('v-flex', {
    class: {
      'pa-0': _vm.$vuetify.breakpoint.smAndDown
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('v-tab-item', {
      key: tab.id,
      attrs: {
        "id": tab.id,
        "lazy": "",
        "transition": false,
        "reverse-transition": false
      }
    }, [_c('router-view', {
      key: tab.id
    })], 1)
  }))], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bfde262","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/PageUser.vue
// module id = 343
// module chunks = 0